export default "__VITE_ASSET__Cmezheax__"